import { Body, Superscript } from "@hypercard/web-components";

type TemplateItemProps = {
  name: string;
  text: string;
  onClick: (text: string) => void;
};

const TemplateItem = ({ name, text, onClick }: TemplateItemProps) => (
  <button
    onClick={() => onClick(text)}
    className="rounded-md bg-white/5 p-4 text-start hover:bg-white/10"
  >
    <Superscript size="md" className="text-white/70">
      Expense Policy
    </Superscript>
    <Body size="lg" weight="regular" className="mt-2 text-white">
      {name}
    </Body>
  </button>
);
const templates = [
  {
    name: "Sales Department",
    text: `Receipt are required for all expenses before making auto-approval decisions.

ELIGIBLE EXPENSES:

- Client Entertainment Expenses: Any client-related entertainment expenses are eligible for auto-approval as long as they are under $100.00 and are purchased on a weekday. This can include a trip to the golf course, fancy dinners, etc.
- Meal Expenses: Any meal expenses are eligible for auto-approval as long as they are under $50.00 and are purchased on a weekday.
- Travel Expenses:
- Employees in the sales department are allowed to only get economy class flight tickets.
- Flight tickets under $350.00 are eligible for auto-approval as long as they are for a company related event.
- Commute expenses such as Taxi’s, Uber and Lyft are eligible as long as they are under $50.00. Commute expenses must be tied to a company related event.
- Accommodation: Employees are encouraged to book mid-range accommodations. Any expenses for luxury accommodations require manual review.
- Accommodations under $200.00 with a receipt can be auto-approved.

OUT OF POLICY EXPENSES:

- Any personal expense unrelated to the company is deemed ineligible for reimbursement.
- Personal care item (toiletries, clothing)
- Fines and Penalties (traffic tickets, parking fines)
`,
  },
  {
    name: "Mexico Offsite",
    text: `This policy for any expense reimbursements that come in for the Company Mexico Offsite from 22nd July 2024 - 28th July 2024. All expenses MUST have a receipt. Any expenses (except flight and hotel expenses, which are booked earlier) with a transaction date that is not within the offsite dates should not be auto-approved. 

ELIGIBLE EXPENSES:

- Flight Tickets: Employees are expected to book an economy class ticket from FLAIR AIRLINES with a maximum flight ticket amount of $700.
- Hotel Accommodation: Employees are expected to book the Ocean View room at Moon Palace Resort with a maximum amount of $500.
- Employees can spend up to a total of $100 in their expense report. These expenses can be for entertainment, souvenirs, etc.
- Any commuting expenses are allowed as long as they are under $50.
`,
  },
  {
    name: "Engineering Department",
    text: `Receipt are required for all expenses before making auto-approval decisions.

ELIGIBLE EXPENSES:

- Coffee Expenses: Any coffee purchases are eligible for auto-approval as long as they are under $10.00 and are purchased on a weekday.
- Meal Expenses: Any meal expenses are eligible for auto-approval as long as they are under $20.00 and are purchased on a weekday.
- Education and Learning: Any expenses related to libraries, education and learning can be auto-approved for an amount under $50.00
- Travel Expenses:
    - Employees in the engineering department are allowed to only get economy class flight tickets.
    - Flight tickets under $150.00 are eligible for auto-approval as long as they are for a company related event.
    - Commute expenses such as Taxi’s, Uber and Lyft are eligible as long as they are under $30.00. Commute expenses must be tied to a company related event.
    - Accommodation: Employees are encouraged to book mid-range accommodations. Any expenses for luxury accommodations require manual review.
        - Accommodations under $100.00 with a receipt can be auto-approved.

OUT OF POLICY EXPENSES:

- Any personal expense unrelated to the company is deemed ineligible for reimbursement.
- Personal entertainment (Movies, sporting events)
- Personal care item (toiletries, clothing)
- Fines and Penalties (traffic tickets, parking fines)`,
  },
];

type TemplateSectionProps = {
  appendText: (text: string) => void;
};
export const TemplateSection = ({ appendText }: TemplateSectionProps) => (
  <div className="mt-6 flex flex-col">
    <Body size="md" weight="medium" className="my-2">
      Select a template
    </Body>
    <div className="flex w-full flex-wrap gap-2">
      {templates.map((template) => (
        <TemplateItem
          key={`template--name-${template.name}`}
          onClick={appendText}
          name={template.name}
          text={template.text}
        />
      ))}
    </div>
  </div>
);
